export default __webpack_public_path__ + "static/media/thumbnail-sourcecode.f316729f.svg";